// removed by extract-text-webpack-plugin
module.exports = {"needoffer-box":"needoffer-box","needoffer-logo":"needoffer-logo","needoffer-box-body":"needoffer-box-body","email-input":"email-input","phone-input":"phone-input","needoffer-content":"needoffer-content","needoffer-footer":"needoffer-footer","has-feedback":"has-feedback","form-group":"form-group","form-control":"form-control","fg-custom":"fg-custom","form-control-feedback":"form-control-feedback","term":"term"};


//////////////////
// WEBPACK FOOTER
// ./components/send-needoffer/_SendNeedofferForm.scss
// module id = ./components/send-needoffer/_SendNeedofferForm.scss
// module chunks = 0